var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIcon99(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66732 6.6665H4.33398C3.08407 6.6665 2.45912 6.6665 2.02101 6.98484C1.87952 7.08764 1.75509 7.21204 1.65229 7.3535C1.33398 7.79164 1.33398 8.41657 1.33398 9.6665C1.33398 10.9164 1.33398 11.5414 1.65229 11.9795C1.75509 12.121 1.87952 12.2454 2.02101 12.3482C2.45912 12.6665 3.08407 12.6665 4.33398 12.6665H11.6673C12.9173 12.6665 13.5422 12.6665 13.9803 12.3482C14.1218 12.2454 14.2462 12.121 14.349 11.9795C14.6673 11.5414 14.6673 10.9164 14.6673 9.6665C14.6673 8.41657 14.6673 7.79164 14.349 7.3535C14.2462 7.21204 14.1218 7.08764 13.9803 6.98484C13.6788 6.7657 13.2887 6.69744 12.6673 6.67617",
    stroke: "#686C70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66602 9H3.67275",
    stroke: "#686C70",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 9.00016C11.622 9.00016 12.6667 7.95549 12.6667 6.66683C12.6667 5.37816 11.622 4.3335 10.3333 4.3335C9.04467 4.3335 8 5.37816 8 6.66683C8 7.95549 9.04467 9.00016 10.3333 9.00016Z",
    stroke: "#686C70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 12.6665L3.33398 14.6665",
    stroke: "#686C70",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 12.6665L12.666 14.6665",
    stroke: "#686C70",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33268 3.3335L7.66602 2.66683M12.9993 2.66683L12.3327 3.3335M10.3327 2.66683V1.3335",
    stroke: "#686C70",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon99);
export default __webpack_public_path__ + "static/media/SidebarIcon99.a5f7e2c0118ad99a4d0ab20664eff977.svg";
export { ForwardRef as ReactComponent };